exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".banner{margin:15px 0 30px}.banner h1{font-weight:bold}\n", ""]);

